var map = {
	"./ar-EG.json": 1862,
	"./bg-BG.json": 5574,
	"./cs-CZ.json": 6974,
	"./de-DE.json": 4048,
	"./el-GR.json": 4020,
	"./en-GB.json": 3171,
	"./es-ES.json": 3840,
	"./fr-FR.json": 4824,
	"./hu-HU.json": 7972,
	"./id-ID.json": 1122,
	"./it-IT.json": 9064,
	"./ko-KO.json": 9671,
	"./nl-NL.json": 4402,
	"./pl-PL.json": 258,
	"./pt-BR.json": 6837,
	"./ro-RO.json": 6362,
	"./ru-RU.json": 9925,
	"./sk-SK.json": 9874,
	"./tr-TR.json": 9961,
	"./uk-UK.json": 2450,
	"./zh-ZH.json": 8160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3631;